import { FC } from 'react';

import { NON_BREAKING_SPACE } from 'utils/constants/common';

import { CheckableCard, Text, VSpacingContainer } from '@hh.ru/magritte-ui';

import FormatMoney from 'components/FormatMoney';

import styles from 'components/AuctionBuilder/AuctionBudget/AuctionBudgetCard/AuctionBudgetCard.module.less';

interface AuctionBudgetCardProps {
    amount: number;
    description: string;
    checked: boolean;
    onClick: () => void;
    dataQa?: string;
}

export const AuctionBudgetCard: FC<AuctionBudgetCardProps> = ({ amount, description, checked, onClick, dataQa }) => {
    return (
        <div className={styles.cardWrapper}>
            <CheckableCard
                flexible
                padding={16}
                borderRadius={16}
                toneHover={true}
                type="radio"
                name="budget"
                checked={checked}
                onChange={onClick}
                data-qa={dataQa}
            >
                <VSpacingContainer default={8}>
                    <Text typography="subtitle-1-semibold">
                        <FormatMoney inCents groupSeparator={NON_BREAKING_SPACE}>
                            {amount}
                        </FormatMoney>
                    </Text>
                    <Text typography="label-3-regular" style="secondary">
                        {description}
                    </Text>
                </VSpacingContainer>
            </CheckableCard>
        </div>
    );
};
